import thumbnail from '@/assets/img/thumbnail.png'

export default {
    bind: function (el, binding,vnode) {
        el.onerror = function(e){
            this.src = thumbnail
            this.onerror = null
        }
    },update:function (el, binding,vnode) {
        el.onerror = function(e){
            this.src = thumbnail
            this.onerror = null
        }
    }
}




// WEBPACK FOOTER //
// ./src/directive/imgerr.js